/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMBannerClickEvent } from '@/data/events/handlers/gtm/BannerClick';
import { GTMBannerViewPayload } from '@/data/types/GTM';

type ProductViewDelegatorProps = {
	gtm?: GTMBannerViewPayload;
};

export const bannerClickDelegator = async (payload: ProductViewDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMBannerClickEvent(gtm);
	}
};
